import { environment } from './../environments/environment';

export const loadState = () => {
    if (!environment.saveState) {
        return undefined;
    }
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        if (environment.saveState) {
            const serializedState = JSON.stringify(state);
            localStorage.setItem('state', serializedState);
        }
    } catch (err) {
        return undefined;
    }
};

export const loadTempState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveTempState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        return undefined;
    }
};

export const deleteTempStorageState = () => {
    localStorage.removeItem('state');
};

export const saveCartState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('cart', serializedState);
    } catch (err) {
        return undefined;
    }
};

export const loadCartState = () => {
    try {
        const serializedState = localStorage.getItem('cart');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const clearCartState = () => {
    try {
        localStorage.setItem('cart', null);
    } catch (err) {
        return undefined;
    }
};
